import { ChangeDetectionStrategy, Component, input, Input } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";
import { IIconComponent } from "@front/m19-ui";

enum Star {
  Empty = 0,
  Half = 1,
  Full = 2,
}

@Component({
  selector: "app-review-score",
  templateUrl: "./review-score.component.html",
  standalone: true,
  imports: [IIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewScoreComponent implements ICellRendererAngularComp {
  readonly Star = Star;

  amazonStyle = input<boolean>(false);

  stars?: Star[];
  _score?: number;

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.score = params.value;
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

  @Input()
  public set score(value: number) {
    this._score = value;
    this.stars = Array<Star>(this.score).fill(Star.Empty);
    if (value < 0 || value > 5) {
      return;
    }
    const x = Math.round(value * 2);
    const numberOfStars = Math.floor(x / 2);
    const halfStar = x % 2 == 1;
    for (let i = 0; i < 5; i++) {
      if (i < numberOfStars) {
        this.stars[i] = Star.Full;
      } else if (i == numberOfStars && halfStar) {
        this.stars[i] = Star.Half;
      } else {
        this.stars[i] = Star.Empty;
      }
    }
  }
}
